import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import * as React from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Box, IconButton, MenuItem } from '@mui/material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Edit } from '@mui/icons-material';

export default function BasicPopover(props) {
  const {
    action1 = props.action1,

    // = {
    //   name: 'View',
    //   icon: <RemoveRedEyeIcon />,
    //   onClick: () => {
    //     handleAction1();
    //   }
    // },
    action2 = props.action2,
    // = {
    //   name: 'Edit',
    //   icon: <Edit />,
    //   onClick: () => {
    //     handleAction2();
    //   }
    // }
    action3 = props.action3,
    action4 = props.action4,
    // = {
    //   name: 'Delete',
    //   icon: <RemoveRedEyeIcon />,
    //   onClick: () => {
    //     handleAction3();
    //   }
    // }
  } = props;
  const [anchorEl2, setAnchorEl2] = React.useState(null);

  const handleClick2 = event => {
    setAnchorEl2(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const itemStyle = {
    display: 'flex',
    gap: '10px',
    alignItems: 'center'
  };

  const open2 = Boolean(anchorEl2);
  const id = open2 ? 'simple-popover' : undefined;

  return (
    <div>
      <IconButton aria-describedby={id} onClick={handleClick2}>
        <MoreHorizIcon />
      </IconButton>
      <Popover
        id={id}
        open={open2}
        anchorEl={anchorEl2}
        onClose={handleClose2}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <Box sx={{ p: 2 }}>
          <MenuItem sx={{ mb: 1.5, ...itemStyle }} onClick={action1.onClick}>
            {action1.icon}
            {action1.name}
          </MenuItem>
          {action2 && (
            <MenuItem
              sx={{ mb: 1.5, ...itemStyle }}
              onClick={() => {
                action2.onClick();
              }}
            >
              {action2.icon}
              {action2.name}
            </MenuItem>
          )}
          {action3 && (
            <MenuItem
              sx={{ mb: 1.5, ...itemStyle }}
              onClick={() => {
                action3.onClick();
              }}
            >
              {action3.icon}
              {action3.name}
            </MenuItem>
          )}
          {action4 && (
            <MenuItem
              sx={{ mb: 1.5, ...itemStyle }}
              onClick={() => {
                action4.onClick();
              }}
            >
              {action4.icon}
              {action4.name}
            </MenuItem>
          )}
        </Box>
      </Popover>
    </div>
  );
}
